import ReportFiltersService from "../services/reports/report-filters-service.js";
import {useQueries} from "@tanstack/react-query";
import contactIdService from "../services/web/contact-id-service.js";
import placeService from "../services/web/place-service.js";
import NatureService from "../services/web/nature-service.js";
import TeamService from "../services/web/team-service.js";
import UserService from "../services/web/user-service.js";
import PlaceService from "../services/web/place-service.js";
import LocationService from "../services/web/location-service.js";
import BosService from "../services/web/bos-service.js";
import dispatchXrayService from "../services/reports/dispatch-xray-service.js";
import AnimalsService from "../services/web/animals-service.js";
import StreetService from "../services/web/street-service.js";
import NeighborhoodService from "../services/web/neighborhood-service.js";
import AreaLayerService from "../services/web/area-layer-service.js";
import AttendanceService from "../services/web/attendance-service.js";
import ProtectionProgramService from "../services/web/protection-program-service.js";
import CapturePlacesService from "../services/web/capture-places-service.js";
import TrafficFlowPointService from "../services/reports/traffic-flow-point-service.js";
import LanesService from "../services/web/lanes-service.js";

const FILTER_QUERIES = [
    {
        key: "dispatchNature",
        enabledFlag: "fetchDispatchNature",
        queryKey: ["dispatch-nature"],
        queryFn: () => ReportFiltersService.dispatchNatures(),
    },
    {
        key: "dispatchNatureGroups",
        enabledFlag: "fetchDispatchNatureGroups",
        queryKey: ["dispatch-nature-groups"],
        queryFn: () => ReportFiltersService.dispatchNaturesGroups(),
    },
    {
        key: "channelNames",
        enabledFlag: "fetchChannelNames",
        queryKey: ["channel-names"],
        queryFn: () => ReportFiltersService.channelNames(),
    },
    {
        key: "streetNames",
        enabledFlag: "fetchStreetNames",
        queryKey: ["street-names"],
        queryFn: () => ReportFiltersService.streetNames(),
    },
    {
        key: "placeNames",
        enabledFlag: "fetchPlaceNames",
        queryKey: ["place-names"],
        queryFn: () => ReportFiltersService.placeNames(),
    },
    {
        key: "neighborhood",
        enabledFlag: "fetchNeighborhood",
        queryKey: ["neighborhood"],
        queryFn: () => ReportFiltersService.neighborhood(),
    },
    {
        key: "allSectors",
        enabledFlag: "fetchAllSectors",
        queryKey: ["all-sectors"],
        queryFn: () => ReportFiltersService.allSectors(),
    },
    {
        key: "occurrenceCityFact",
        enabledFlag: "fetchOccurrenceCityFact",
        queryKey: ["occurrence-city-fact"],
        queryFn: () => ReportFiltersService.occurrencesCityFact(),
    },
    {
        key: "placeTypes",
        enabledFlag: "fetchPlaceTypes",
        queryKey: ["place-types"],
        queryFn: () => ReportFiltersService.placeTypes(),
    },
    {
        key: "getVehicles",
        enabledFlag: "fetchGetVehicles",
        queryKey: ["get-vehicles"],
        queryFn: () => ReportFiltersService.getVehicles(),
    },
    {
        key: "storageOptions",
        enabledFlag: "fetchStorage",
        queryKey: ["storage"],
        queryFn: () => ReportFiltersService.allMaterialStorages(),
    },
    {
        key: "materialStorageOptions",
        enabledFlag: "fetchMaterialStorage",
        queryKey: ["material-storage"],
        queryFn: () => ReportFiltersService.allMaterials(),
    },
    {
        key: "groupOptions",
        enabledFlag: "fetchGroup",
        queryKey: ["group"],
        queryFn: () => ReportFiltersService.allMaterialGroups(),
    },
    {
        key: "userEffectiveNameWarOptions",
        enabledFlag: "fetchEffectiveNameWar",
        queryKey: ["effectiveNameWar"],
        queryFn: () => ReportFiltersService.allEffectiveNameWar(),
    },
    {
        key: "userEffectiveNameOptions",
        enabledFlag: "fetchEffectiveName",
        queryKey: ["effectiveName"],
        queryFn: () => ReportFiltersService.allEffectiveNames(),
    },
    {
        key: "userEffectiveCpfOptions",
        enabledFlag: "fetchEffectiveCpf",
        queryKey: ["effectiveCpf"],
        queryFn: () => ReportFiltersService.allEffectiveCpf(),
    },
    {
        key: "pclNames",
        enabledFlag: "fetchPclNames",
        queryKey: ["pcl-names"],
        queryFn: () => ReportFiltersService.pclNames(),
    },
    {
        key: "natureGroups",
        enabledFlag: "fetchNatureGroups",
        queryKey: ["nature-groups"],
        queryFn: () => ReportFiltersService.natureGroups(),
    },
    {
        key: "natureActions",
        enabledFlag: "fetchNatureActions",
        queryKey: ["nature-actions"],
        queryFn: () => ReportFiltersService.natureActions(),
    },
    {
        key: "leadersIdentification",
        enabledFlag: "fetchLeadersIdentification",
        queryKey: ["leaders-identification"],
        queryFn: () => ReportFiltersService.leadersIdentification(),
    },
    {
        key: "allowedOnly",
        enabledFlag: "fetchAllowedOnly",
        queryKey: ["allowed-only"],
        queryFn: () => ReportFiltersService.allowedOnly(),
    },
    {
        key: "allTeams",
        enabledFlag: "fetchAllTeams",
        queryKey: ["all-teams"],
        queryFn: () => ReportFiltersService.allTeams(),
    },
    {
        key: "allVehicles",
        enabledFlag: "fetchAllVehicles",
        queryKey: ["all-vehicles"],
        queryFn: () => ReportFiltersService.allVehicles(),
    },
    {
        key: "occurrenceDetailsNature",
        enabledFlag: "fetchOccurrenceDetailsNature",
        queryKey: ["occurrence-details-nature"],
        queryFn: () => ReportFiltersService.occurrencesDetailsNatures(),
    },
    {
        key: "occurrenceVehicleClassification",
        enabledFlag: "fetchOccurrenceVehicleClassification",
        queryKey: ["occurrence-vehicle-classification"],
        queryFn: () => ReportFiltersService.occurrenceVehicleClassification(),
    },
    {
        key: "occurrencesDetails",
        enabledFlag: "fetchOccurrencesDetails",
        queryKey: ["get-occurrences-details"],
        queryFn: () => NatureService.getOccurrencesDetailsNatures(),
    },
    {
        key: "encounterAgents",
        enabledFlag: "fetchEncounterAgents",
        queryKey: ["encounter-agents"],
        queryFn: () => ReportFiltersService.encounterAgents(),
    },
    {
        key: "lastEvent",
        queryKey: ['last-event'],
        enabledFlag: "fetchLastEvent",
        queryFn: () => contactIdService.lastEvent().then(({data}) => data.map(d => ({label: d.text, value: d.id}))),
    },
    {
        key: "placesByEvent",
        queryKey: ['places-by-event'],
        enabledFlag: "fetchPlacesByEvent",
        queryFn: () => placeService.getPlacesByEvent(),
    },
    {
        key: "userNameAck",
        queryKey: ['user-name-ack'],
        enabledFlag: "fetchUserNameAck",
        queryFn: () => UserService.getUserNameAck(),
    },
    {
        key: "boXRayStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["boXRay-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "boXRayResponsible",
        enabledFlag: "fetchBOXrayResponsible",
        queryKey: ["boXRay-responsible"],
        queryFn: () => ReportFiltersService.boXRayResponsible(),
    },
    {
        key: "boXRayReasons",
        enabledFlag: "fetchBOXrayReason",
        queryKey: ["boXRay-reasons"],
        queryFn: () => ReportFiltersService.boXRayReasons().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...data]),
    },
    {
        key: "boXRayTeam",
        enabledFlag: "fetchBOXrayTeam",
        queryKey: ["boXRay-team"],
        queryFn: () => TeamService.boTeams(),
    },
    {
        key: "boXRayNeighborhood",
        enabledFlag: "fetchBOXrayNeighborhoods",
        queryKey: ["boXRay-neighborhood"],
        queryFn: () => ReportFiltersService.boXRayNeighborhoods(),
    },
    {
        key: "boXRayStreets",
        enabledFlag: "fetchBOXrayStreets",
        queryKey: ["boXRay-streets"],
        queryFn: () => ReportFiltersService.boXRayStreets(),
    },
    {
        key: "boXRayConditions",
        enabledFlag: "fetchBOXrayConditions",
        queryKey: ["boXRay-conditions"],
        queryFn: () => ReportFiltersService.boXRayConditions(),
    },
    {
        key: "boResponsible",
        enabledFlag: "fetchBOResponsible",
        queryKey: ["bo-responsible"],
        queryFn: () => ReportFiltersService.leadersIdentification().then(data => [{ label: "Não informado", value: -10 }, ...data]),
    },
    {
        key: "boResponsibleReason",
        enabledFlag: "fetchBOResponsibleReason",
        queryKey: ["bo-responsible-reason"],
        queryFn: () => ReportFiltersService.boResponsibleReasons().then(data => [{ label: "Não informado", value: "WITHOUT-REASON" }, ...data]),
    },
    {
        key: "boStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["bo-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "activitiesJournalTeam",
        enabledFlag: "fetchActivitiesJournalTeam",
        queryKey: ['activities-journal-team'],
        queryFn: () => ReportFiltersService.getActivityJournalTeams(),
    },
    {
        key: "activitiesJournalResponsible",
        enabledFlag: "fetchActivitiesJournalResponsible",
        queryKey: ['activities-journal-responsible'],
        queryFn: () => ReportFiltersService.getActivityJournalResponsible(),
    },
    {
        key: "boXRayStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["boXRay-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "boXRayResponsible",
        enabledFlag: "fetchBOXrayResponsible",
        queryKey: ["boXRay-responsible"],
        queryFn: () => ReportFiltersService.boXRayResponsible(),
    },
    {
        key: "boXRayReasons",
        enabledFlag: "fetchBOXrayReason",
        queryKey: ["boXRay-reasons"],
        queryFn: () => ReportFiltersService.boXRayReasons().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...data]),
    },
    {
        key: "boXRayTeam",
        enabledFlag: "fetchBOXrayTeam",
        queryKey: ["boXRay-team"],
        queryFn: () => ReportFiltersService.allTeams().then(data => [{ label: "Não informado", value: "WITHOUT-TEAM" }, ...data]),
    },
    {
        key: "boXRayNeighborhood",
        enabledFlag: "fetchBOXrayNeighborhoods",
        queryKey: ["boXRay-neighborhood"],
        queryFn: () => ReportFiltersService.boXRayNeighborhoods(),
    },
    {
        key: "boXRayStreets",
        enabledFlag: "fetchBOXrayStreets",
        queryKey: ["boXRay-streets"],
        queryFn: () => ReportFiltersService.boXRayStreets(),
    },
    {
        key: "boXRayConditions",
        enabledFlag: "fetchBOXrayConditions",
        queryKey: ["boXRay-conditions"],
        queryFn: () => ReportFiltersService.boXRayConditions(),
    },
    {
        key: "boResponsible",
        enabledFlag: "fetchBOResponsible",
        queryKey: ["bo-responsible"],
        queryFn: () => ReportFiltersService.leadersIdentification().then(data => [{ label: "Não informado", value: -10 }, ...data]),
    },
    {
        key: "boResponsibleReason",
        enabledFlag: "fetchBOResponsibleReason",
        queryKey: ["bo-responsible-reason"],
        queryFn: () => ReportFiltersService.boResponsibleReasons().then(data => [{ label: "Não informado", value: "WITHOUT-REASON" }, ...data]),
    },
    {
        key: "boStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["bo-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "activitiesJournalTeam",
        enabledFlag: "fetchActivitiesJournalTeam",
        queryKey: ['activities-journal-team'],
        queryFn: () => ReportFiltersService.getActivityJournalTeams(),
    },
    {
        key: "activitiesJournalResponsible",
        enabledFlag: "fetchActivitiesJournalResponsible",
        queryKey: ['activities-journal-responsible'],
        queryFn: () => ReportFiltersService.getActivityJournalResponsible(),
    },
    {
        key: "boXRayStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["boXRay-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "boXRayResponsible",
        enabledFlag: "fetchBOXrayResponsible",
        queryKey: ["boXRay-responsible"],
        queryFn: () => ReportFiltersService.boXRayResponsible(),
    },
    {
        key: "boXRayReasons",
        enabledFlag: "fetchBOXrayReason",
        queryKey: ["boXRay-reasons"],
        queryFn: () => ReportFiltersService.boXRayReasons().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...data]),
    },
    {
        key: "boXRayTeam",
        enabledFlag: "fetchBOXrayTeam",
        queryKey: ["boXRay-team"],
        queryFn: () => ReportFiltersService.allTeams().then(data => [{ label: "Não informado", value: "WITHOUT-TEAM" }, ...data]),
    },
    {
        key: "boXRayNeighborhood",
        enabledFlag: "fetchBOXrayNeighborhoods",
        queryKey: ["boXRay-neighborhood"],
        queryFn: () => ReportFiltersService.boXRayNeighborhoods(),
    },
    {
        key: "boXRayStreets",
        enabledFlag: "fetchBOXrayStreets",
        queryKey: ["boXRay-streets"],
        queryFn: () => ReportFiltersService.boXRayStreets(),
    },
    {
        key: "boXRayConditions",
        enabledFlag: "fetchBOXrayConditions",
        queryKey: ["boXRay-conditions"],
        queryFn: () => ReportFiltersService.boXRayConditions(),
    },
    {
        key: "boResponsible",
        enabledFlag: "fetchBOResponsible",
        queryKey: ["bo-responsible"],
        queryFn: () => ReportFiltersService.leadersIdentification().then(data => [{ label: "Não informado", value: -10 }, ...data]),
    },
    {
        key: "boResponsibleReason",
        enabledFlag: "fetchBOResponsibleReason",
        queryKey: ["bo-responsible-reason"],
        queryFn: () => ReportFiltersService.boResponsibleReasons().then(data => [{ label: "Não informado", value: "WITHOUT-REASON" }, ...data]),
    },
    {
        key: "boStatus",
        enabledFlag: "fetchBOStatus",
        queryKey: ["bo-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "occurrenceDetailsCondition",
        enabledFlag: "fetchOccurrencesDetailsCondition",
        queryKey: ["occurrence-details-condition"],
        queryFn: () => ReportFiltersService.occurrenceDetailsCondition(),
    },
    {
        key: "occurrenceDetailsNeighborhood",
        enabledFlag: "fetchOccurrencesDetailsNeighborhood",
        queryKey: ["occurrence-details-neighborhood"],
        queryFn: () => ReportFiltersService.occurrenceDetailsNeighborhood(),
    },
    {
        key: "garrisonMapTeam",
        enabledFlag: "fetchGarrisonMapTeam",
        queryKey: ["garrison-map-team"],
        queryFn: () => ReportFiltersService.allTeams().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceGuard",
        enabledFlag: "fetchDispatchSequenceGuard",
        queryKey: ["dispatch-sequence-Guard"],
        queryFn: () => UserService.allowedOnly(),
    },
    {
        key: "dispatchSequenceAnimals",
        enabledFlag: "fetchDispatchSequenceAnimals",
        queryKey: ["dispatch-sequence-animals"],
        queryFn: () => AnimalsService.all().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceReason",
        enabledFlag: "fetchDispatchSequenceReason",
        queryKey: ["dispatch-sequence-reason"],
        queryFn: () => NatureService.dispatchNatures().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceGroupReason",
        enabledFlag: "fetchDispatchSequenceGroupReason",
        queryKey: ["dispatch-sequence-group-reason"],
        queryFn: () => NatureService.getNatureGroups().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceStreet",
        enabledFlag: "fetchDispatchSequenceStreet",
        queryKey: ["dispatch-sequence-street"],
        queryFn: () => StreetService.streetNames().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequencePlace",
        enabledFlag: "fetchDispatchSequencePlace",
        queryKey: ["dispatch-sequence-place"],
        queryFn: () => PlaceService.placeNames().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceTypePlace",
        enabledFlag: "fetchDispatchSequenceTypePlace",
        queryKey: ["dispatch-sequence-type-place"],
        queryFn: () => PlaceService.getPlaceTypes().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceNeighborhood",
        enabledFlag: "fetchDispatchSequenceNeighborhood",
        queryKey: ["dispatch-sequence-neighborhood"],
        queryFn: () => NeighborhoodService.getNames().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceSector",
        enabledFlag: "fetchDispatchSequenceSector",
        queryKey: ["dispatch-sequence-sector"],
        queryFn: () => AreaLayerService.allSectors().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceTeam",
        enabledFlag: "fetchDispatchSequenceTeam",
        queryKey: ["dispatch-sequence-team"],
        queryFn: () => TeamService.getAllTeams().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "dispatchSequenceOccurrences",
        enabledFlag: "fetchDispatchSequenceOccurrences",
        queryKey: ["dispatch-sequence-occurrences"],
        queryFn: () => BosService.otherDocuments(),
    },
    {
        key: "specificDispatchNatures",
        enabledFlag: "specificDispatchNatures",
        queryKey: ["specific-dispatch-natures"],
        queryFn: () => dispatchXrayService.getSpecificDispatchNatures(),
    },
    {
        key: "specificDispatchNaturesGroups",
        enabledFlag: "specificDispatchNaturesGroups",
        queryKey: ["specific-dispatch-natures-groups"],
        queryFn: () => dispatchXrayService.getSpecificDispatchNaturesGroups(),
    },
    {
        key: "boListReason",
        enabledFlag: "fetchBOListReason",
        queryKey: ["bo-list-reason"],
        queryFn: () => NatureService.getNatureAllNames().then(data => [{ label: "Não informado", value: "0_WITHOUT" }, ...data]),
    },
    {
        key: "boListLeader",
        enabledFlag: "fetchBOListLeader",
        queryKey: ["bo-list-leader"],
        queryFn: () => ReportFiltersService.boXRayResponsible(),
    },
    {
        key: "boListTeam",
        enabledFlag: "fetchBOListTeam",
        queryKey: ["bo-list-team"],
        queryFn: () => TeamService.boTeams(),
    },
    {
        key: "boListGuard",
        enabledFlag: "fetchBOListGuard",
        queryKey: ["bo-list-guard"],
        queryFn: () => UserService.getListBOContingent(),
    },
    {
        key: "boListPlaces",
        enabledFlag: "fetchBOListPlaces",
        queryKey: ["bo-list-places"],
        queryFn: () => PlaceService.getBoPlaces(),
    },
    {
        key: "boListStreet",
        enabledFlag: "fetchBOListStreet",
        queryKey: ["bo-list-street"],
        queryFn: () => LocationService.getBoStreets(),
    },
    {
        key: "boListNeighborhood",
        enabledFlag: "fetchBOListNeighborhood",
        queryKey: ["bo-list-neighborhood"],
        queryFn: () => LocationService.getBoNeighborhood(),
    },
    {
        key: "boListSector",
        enabledFlag: "fetchBOListSector",
        queryKey: ["bo-list-sector"],
        queryFn: () => BosService.getBoSector(),
    },
    {
        key: "attendanceXRayNature",
        enabledFlag: "fetchAttendanceXRayNature",
        queryKey: ["attendance-x-ray-nature"],
        queryFn: () => NatureService.getAttendanceNatures().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...data]),
    },
    {
        key: "attendanceXRayNatureGroup",
        enabledFlag: "fetchAttendanceXRayNatureGroup",
        queryKey: ["attendance-x-ray-nature-group"],
        queryFn: () => NatureService.getAttendanceNatureGroups().then(data => [{ label: "Não informado", value: "WITHOUT-NATURE-GROUP" }, ...data]),
    },
    {
        key: "attendanceXRayAttendants",
        enabledFlag: "fetchAttendanceXRayAttendants",
        queryKey: ["attendance-x-ray-attendants"],
        queryFn: () => UserService.attendantsIdentifications(),
    },
    {
        key: "attendanceXRayTeam",
        enabledFlag: "fetchAttendanceXRayTeam",
        queryKey: ["attendance-x-ray-team"],
        queryFn: () => TeamService.attendanceTeams(),
    },
    {
        key: "attendanceXRayStreet",
        enabledFlag: "fetchAttendanceXRayStreet",
        queryKey: ["attendance-x-ray-street"],
        queryFn: () => StreetService.getAttendanceStreets().then(data => [{ label: "Não informado", value: "WITHOUT-STREET" }, ...data]),
    },
    {
        key: "attendanceXRaySector",
        enabledFlag: "fetchAttendanceXRaySector",
        queryKey: ["attendance-x-ray-sector"],
        queryFn: () => AttendanceService.getAttendanceSectors(),
    },
    {
        key: "attendanceXRayChannel",
        enabledFlag: "fetchAttendanceXRayChannel",
        queryKey: ["attendance-x-ray-channel"],
        queryFn: () => AttendanceService.getAttendanceChannels(),
    },
    {
        key: "encounterListTeam",
        enabledFlag: "fetchEncounterListTeam",
        queryKey: ["encounter-list-team"],
        queryFn: () => TeamService.encounterTeams(),
    },
    {
        key: "geoComparisonReason",
        enabledFlag: "fetchGeoComparisonReason",
        queryKey: ["geo-comparison-reason"],
        queryFn: () => NatureService.getOccurrencesDetailsNatures(),
    },
    {
        key: "geoComparisonCityFact",
        enabledFlag: "fetchGeoComparisonCityFact",
        queryKey: ["geo-comparison-city-fact"],
        queryFn: () => ReportFiltersService.occurrencesCityFact(),
    },
    {
        key: "userNameId",
        enabledFlag: "fetchUserNameId",
        queryKey: ["user-name-id"],
        queryFn: () => UserService.getUsersNamesIds(),
    },
    {
        key: "userLoginId",
        enabledFlag: "fetchUserLoginId",
        queryKey: ["user-login-id"],
        queryFn: () => UserService.getUsersLoginIds(),
    },
    {
        key: "userCpfId",
        enabledFlag: "fetchUserCpfId",
        queryKey: ["user-cpf-id"],
        queryFn: () => UserService.getUsersCpfIds(),
    },
    {
        key: "boApprehensionsNature",
        enabledFlag: "fetchBoApprehensionsNature",
        queryKey: ["bo-apprehensions-nature"],
        queryFn: () => ReportFiltersService.boXRayReasons(),
    },
    {
        key: "boApprehensionsNatureGroup",
        enabledFlag: "fetchBoApprehensionsNatureGroup",
        queryKey: ["bo-apprehensions-nature-group"],
        queryFn: () => ReportFiltersService.dispatchNaturesGroups(),
    },
    {
        key: "boApprehensionsStreet",
        enabledFlag: "fetchBoApprehensionsStreet",
        queryKey: ["bo-apprehensions-street"],
        queryFn: () => LocationService.getBoStreets(),
    },
    {
        key: "boApprehensionsNeighborhood",
        enabledFlag: "fetchBoApprehensionsNeighborhood",
        queryKey: ["bo-apprehensions-neighborhood"],
        queryFn: () => LocationService.getBoNeighborhood(),
    },
    {
        key: "boApprehensionsType",
        enabledFlag: "fetchBoApprehensionsType",
        queryKey: ["bo-apprehensions-type"],
        queryFn: () => ReportFiltersService.apprehensionsTypes(),
    },
    {
        key: "boApprehensionsSubtype",
        enabledFlag: "fetchBoApprehensionsSubtype",
        queryKey: ["bo-apprehensions-subtype"],
        queryFn: () => ReportFiltersService.apprehensionsSubtypes(),
    },
    {
        key: "natureDeviationReason",
        enabledFlag: "fetchNatureDeviationReason",
        queryKey: ["nature-deviation-reason"],
        queryFn: () => ReportFiltersService.dispatchNatures(),
    },
    {
        key: "natureDeviationReasonGroup",
        enabledFlag: "fetchNatureDeviationReasonGroup",
        queryKey: ["nature-deviation-reason-group"],
        queryFn: () => ReportFiltersService.dispatchNaturesGroups(),
    },
    {
        key: "fleetSuppliesPrefix",
        enabledFlag: "fetchFleetSuppliesPrefix",
        queryKey: ["fleet-supplies-prefix"],
        queryFn: () => ReportFiltersService.fleetSuppliesPrefix(),
    },
    {
        key: "fleetSuppliesGasStation",
        enabledFlag: "fetchFleetSuppliesGasStation",
        queryKey: ["fleet-supplies-gas-station"],
        queryFn: () => ReportFiltersService.fleetSuppliesGasStation(),
    },
    {
        key: "alarmStatisticsQuestions",
        enabledFlag: "fetchAlarmStatisticsQuestions",
        queryKey: ["alarm-statistics-questions"],
        queryFn: () => ReportFiltersService.alarmQuestions(),
    },
    {
        key: "alarmStatisticsPCL",
        enabledFlag: "fetchAlarmStatisticsPCL",
        queryKey: ["alarm-statistics-pcl"],
        queryFn: () => ReportFiltersService.alarmPcl(),
    },
    {
        key: "alarmStatisticsType",
        enabledFlag: "fetchAlarmStatisticsType",
        queryKey: ["alarm-statistics-type"],
        queryFn: () => ReportFiltersService.alarmEventSource(),
    },
    {
        key: "dispatchQualityUser",
        enabledFlag: "fetchDispatchQualityUser",
        queryKey: ["dispatch-quality-user"],
        queryFn: () => ReportFiltersService.dispatchUsers(),
    },
    {
        key: "corporationActionsTeam",
        enabledFlag: "fetchCorporationActionsTeam",
        queryKey: ["corporation-actions-team"],
        queryFn: () => ReportFiltersService.garrisonTeams(),
    },
    {
        key: "documentExpirationTeam",
        enabledFlag: "fetchDocumentExpirationTeam",
        queryKey: ["document-expiration-team"],
        queryFn: () => ReportFiltersService.getTeams(),
    },
    {
        key: "solicitationXRayCreator",
        enabledFlag: "fetchSolicitationXRayCreator",
        queryKey: ["solicitation-xray-creator"],
        queryFn: () => ReportFiltersService.solicitationUsers(),
    },
    {
        key: "solicitationXRayNature",
        enabledFlag: "fetchSolicitationXRayNature",
        queryKey: ["solicitation-xray-nature"],
        queryFn: () => ReportFiltersService.solicitationNatures(),
    },
    {
        key: "solicitationXRayOrganization",
        enabledFlag: "fetchSolicitationXRayOrganization",
        queryKey: ["solicitation-xray-organization"],
        queryFn: () => ReportFiltersService.solicitationOrganizations(),
    },
    {
        key: "trafficVehicleStayPCL",
        enabledFlag: "fetchTrafficVehicleStayPCL",
        queryKey: ["traffic-vehicle-stay-pcl"],
        queryFn: () => ReportFiltersService.vehicleStayPCLs(),
    },
    {
        key: "trafficFlowPointVehicleTypes",
        enabledFlag: "fetchTrafficFlowPointVehicleTypes",
        queryKey: ["traffic-flow-point-vehicle-types"],
        queryFn: () => TrafficFlowPointService.vehicleTypes(),
    },
    {
        key: "trafficFlowPointCapturePlaces",
        enabledFlag: "fetchTrafficFlowPointCapturePlaces",
        queryKey: ["traffic-flow-point-capture-places"],
        queryFn: () => CapturePlacesService.options(),
    },
    {
        key: "boAuditStatus",
        enabledFlag: "fetchBoAuditorshipStatus",
        queryKey: ["bo-auditorship-status"],
        queryFn: () => ReportFiltersService.boStatus(),
    },
    {
        key: "boAuditValidatedLogin",
        enabledFlag: "fetchBoAuditorshipValidatedLogin",
        queryKey: ["bo-auditorship-validated-login"],
        queryFn: () => ReportFiltersService.boValidatorLogin(),
    },
    {
        key: "boAuditValidatedName",
        enabledFlag: "fetchBoAuditorshipValidatedName",
        queryKey: ["bo-auditorship-validated-name"],
        queryFn: () => ReportFiltersService.boValidatorName(),
    },
    {
        key: "boAuditValidatedCPF",
        enabledFlag: "fetchBoAuditorshipValidatedCPF",
        queryKey: ["bo-auditorship-validated-cpf"],
        queryFn: () => ReportFiltersService.boValidatorCPF(),
    },
    {
        key: "boAuditCreatedLogin",
        enabledFlag: "fetchBoAuditorshipCreatedLogin",
        queryKey: ["bo-auditorship-created-login"],
        queryFn: () => ReportFiltersService.boCreatorLogin(),
    },
    {
        key: "boAuditCreatedName",
        enabledFlag: "fetchBoAuditorshipCreatedName",
        queryKey: ["bo-auditorship-created-name"],
        queryFn: () => ReportFiltersService.boCreatorName(),
    },
    {
        key: "boAuditCreatedCPF",
        enabledFlag: "fetchBoAuditorshipCreatedCPF",
        queryKey: ["bo-auditorship-created-cpf"],
        queryFn: () => ReportFiltersService.boCreatorCPF(),
    },
    {
        key: "sosManagementActionsUsers",
        enabledFlag: "fetchSosManagementActionsUsers",
        queryKey: ["sos-management-actions-users"],
        queryFn: () => ReportFiltersService.sosActionUsers(),
    },
    {
        key: "agentAbsenceReason",
        enabledFlag: "fetchAgentAbsenceReason",
        queryKey: ["agent-absence-reason"],
        queryFn: () => ReportFiltersService.getAbsenceReason(),
    },
    {
        key: 'sosRecordsTypePlace',
        enabledFlag: 'fetchSosRecordsTypePlace',
        queryKey: ['sos-records-type-place'],
        queryFn: () => PlaceService.getTypes().then(data => [{ label: "Não informado", value: "WITHOUT-TYPE-PLACE" }, ...data.map(d => ({ value: d.id, label: d.text })) ])
    },
    {
        key: 'sosHistoryActions',
        enabledFlag: 'fetchSosHistoryActions',
        queryKey: ['sos-history-actions'],
        queryFn: () => [{ label: "Cadastro pela web", value: "NEW_WEB" },
            { label: "Cadastro pelo app", value: "NEW_MOBILE" },
            { label: "Ativação", value: "ACTIVATION" },
            { label: "Inativação - Outros", value: "INACTIVATION" },
            { label: "Inativação - Recusa", value: "INACTIVATION_REVOCATION" },
            { label: "Inativação - Revogação", value: "INACTIVATION_REFUSAL" },
            { label: "Inativação - Desligamento", value: "INACTIVATION_TERMINATION" },
            { label: "Atendimento", value: "ATTENDANCE" },
            { label: "Entrevista", value: "INTERVIEW" },
            { label: "Ligação", value: "CALL" },
            { label: "Ronda", value: "PATROL" },
            { label: "Visita", value: "VISIT" },
            { label: "Encaminhamento", value: "REFERRED" },
            { label: "Orientação", value: "GUIDANCE" },
            { label: "Comentário", value: "COMMENT" },
            { label: "SOS - aberto", value: "EVENT_START" },
            { label: "SOS - endereço selecionado", value: "EVENT_TARGET_ADDRESS" },
            { label: "SOS - cidadão selecionado", value: "EVENT_TARGET_CITIZEN" },
            { label: "SOS - assumido", value: "EVENT_ACK" },
            { label: "SOS - finalizado", value: "EVENT_END" },
            { label: "Mudança de senha", value: "PASSWORD_CHANGE" },
            { label: "Recuperação de senha", value: "PASSWORD_RECOVERY" }]
    },
    {
        key: 'sosRecordsProtectionPrograms',
        enabledFlag: 'fetchSosRecordsProtectionPrograms',
        queryKey: ['sos-records-protection-programs'],
        queryFn: () => ProtectionProgramService.options()
    },
    {
        key: 'sosHistoryProtectionPrograms',
        enabledFlag: 'fetchSosHistoryProtectionPrograms',
        queryKey: ['sos-history-protection-programs'],
        queryFn: () => ReportFiltersService.sosProtectionPrograms()
    },
    {
        key: 'sosHistoryCitizens',
        enabledFlag: 'fetchSosHistoryCitizens',
        queryKey: ['sos-history-citizens'],
        queryFn: () => ReportFiltersService.sosCitizens()
    },
    {
        key: 'sosHistoryResponsible',
        enabledFlag: 'fetchSosHistoryResponsible',
        queryKey: ['sos-history-responsible'],
        queryFn: () => ReportFiltersService.sosResponsible()
    },
    {
        key: 'sosHistoryCreatedBy',
        enabledFlag: 'fetchSosHistoryCreatedBy',
        queryKey: ['sos-history-created-by'],
        queryFn: () => ReportFiltersService.sosCreatedBy()
    },
    {
        key: 'vehiclePassagesOperationGroups',
        enabledFlag: 'fetchVehiclePassagesOperationGroups',
        queryKey: ['vehicle-passages-operation-groups'],
        queryFn: () => ReportFiltersService.vehiclePassagesOperationGroups()
    },
];

const useReportFiltersFetch = (flags) => {
    const queries = useQueries({
        queries: FILTER_QUERIES.map((item) => ({
            queryKey: item.queryKey,
            queryFn: item.queryFn,
            enabled: !!flags[item.enabledFlag],
        })),
    });

    return FILTER_QUERIES.reduce((acc, item, index) => {
        acc[item.key] = queries[index]?.data ?? [];
        return acc;
    }, {});
}

export default useReportFiltersFetch;